export function categoryNameToIcon(categoryName, categories) {
  if (!categoryName) return "mdi-dots-horizontal";
  const category = categories.find(c => c.name == categoryName);
  return category ? category.icon : "mdi-dots-horizontal";
}

export function categoryNameToPretty(categoryName, categories) {
  if (!categoryName) return "Altro";
  const category = categories.find(c => c.name == categoryName);
  return category ? category.description : "Altro";
}

export function categoryNameToColor(
  categoryName,
  categories,
  defaultColor = "white"
) {
  if (!categoryName) return defaultColor;
  const category = categories.find(c => c.name == categoryName);
  return category ? category.color : defaultColor;
}
